module.exports = __webpack_public_path__ + "static/img/logo-inverted.5fea14cb.svg";